import React from 'react';
import { useProgramContext } from '../../../../../../hooks/useProgramContext';
import CreationFlowDialog from '../../../capability-setup/CreationFlowDialog';
import type { AssessmentDraft } from '../../../capability-setup/create/assessmentDrafts';
import { useCapabilityRoles } from '../../../capability-setup/useCapabilityRoles';
import { useCapabilitySets } from '../../../capability-setup/useCapabilitySets';

/**
 * Run Assessment, opened over the dashboard on an Assessment that is still
 * being built (Continue on its card, at Design): it reopens at the step it was
 * left. Mounted only while it is open: that is when it reads the roles the
 * flow offers, and it waits for them, since what the Assessment measures is
 * worked out from them.
 */
const ResumeAssessmentDialog: React.FC<{ draft: AssessmentDraft; onClose: () => void }> = ({ draft, onClose }) => {
  const { orgId, isPlatformAdmin } = useProgramContext();
  const { roles, teamsList, mode } = useCapabilityRoles(orgId, isPlatformAdmin);
  const capabilitySets = useCapabilitySets(orgId, isPlatformAdmin);
  return (
    <CreationFlowDialog
      kind={mode === 'loading' || capabilitySets.mode === 'loading' ? null : 'assessment'}
      roles={roles}
      sets={capabilitySets.sets}
      teamsListId={teamsList?.listId ?? null}
      assessmentDraft={draft}
      onClose={onClose}
    />
  );
};

export default ResumeAssessmentDialog;
